import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : from, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] container-x flex items-center justify-center py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-gold mb-8">
          <ArrowLeft className="w-4 h-4" /> Anasayfa
        </Link>
        <span className="section-eyebrow">Giriş</span>
        <h1 className="font-display text-4xl md:text-5xl mt-3 mb-2">Tekrar hoş <span className="italic gold-gradient-text">geldiniz</span>.</h1>
        <p className="text-white/60 mb-8">Hesabınıza erişmek için giriş yapın.</p>

        <form onSubmit={submit} data-testid="login-form" className="space-y-5">
          {error && <div className="bg-red-950/40 border border-red-800 text-red-200 p-3 text-sm">{error}</div>}
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-white/60 mb-2 inline-block">E-posta</span>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-style" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-white/60 mb-2 inline-block">Şifre</span>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-style" />
          </label>
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60">
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"} <LogIn className="w-4 h-4" />
          </button>
        </form>

        <div className="mt-8 text-center text-sm text-white/60">
          Henüz hesabınız yok mu?{" "}
          <Link to="/kayit" className="text-gold hover:underline">Kayıt olun</Link>
        </div>
      </div>

      <style>{`
        .input-style { width: 100%; background: #0F0F14; border: 1px solid rgba(255,255,255,0.08); padding: 0.75rem 1rem; color: white; font-family: 'Outfit', sans-serif; outline: none; transition: border-color 0.2s ease; }
        .input-style:focus { border-color: rgba(212,175,55,0.6); }
      `}</style>
    </div>
  );
}
